import { X, Loader, Circle, CircleCheckBig } from "lucide-react";
import { twMerge } from "tailwind-merge";

interface StepIconProps {
    step: number;
    currentStep: number;
    errorStep: number;
    className: string;
    size?: number;
  }
  
  export function StepIcon({
    step,
    className,
    currentStep,
    errorStep,
    size = 16,
  }: StepIconProps) {
    if (errorStep && step >= errorStep) {
      return <X size={size} className={className} />;
    }
    if (step === currentStep) {
      className = twMerge(className, "animate-spin");
      return <Loader size={size} className={className} />;
    }
    if (step > currentStep) {
      return <Circle size={size} className={className} />;
    }
    return <CircleCheckBig size={size} className={className} />;
  }
  